import { Button, Overlay, Popover, PopoverContent } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useRef, useState } from 'react'

import Tag from 'components/ui/tag/Tag'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { ILmsProfileModel } from 'models/lmsProfile.model'

import { prefix } from '../constants'

export interface TagsProps {
  id: string
  profiles: ILmsProfileModel[]
}
export const Tags = ({ id, profiles }) => {
  const { t } = useTranslation()
  const prefixContent = 'courses.show.content'
  const tRelative = useTranslationRankmi({ prefix })

  const target = useRef(null)
  const [show, setShow] = useState(false)

  const handleTags = (lmsProfiles: ILmsProfileModel[]) => {
    if (lmsProfiles?.length) {
      return lmsProfiles.map((profile) => (
        <Tag
          key={profile.id}
          text={profile.name}
          color={profile.color}
          size="sm"
        />
      ))
    }
    return t(`${prefixContent}.noProfiles`)
  }
  return (
    <>
      <Button
        variant="link"
        className="m-0 p-0"
        ref={target}
        onClick={() => setShow(!show)}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >
        {tRelative(`data.profiles`, {
          count: profiles?.length || 0,
        })}
      </Button>
      <Overlay target={target.current} show={show}>
        <Popover id={id}>
          <PopoverContent>{handleTags(profiles)}</PopoverContent>
        </Popover>
      </Overlay>
    </>
  )
}
export default Tags
